/**
 * @description Component-GetMarginButton
 */
import { FC, useCallback } from 'react';

import { Button } from '@/components/Button';
import { useAbcFaucetSendTx } from '@/features/futures/query';
import { useChainId, useDappChainConfig, useUserAddr } from '@/hooks/web3/useChain';
import { IButtonProps } from '@/types/button';

import { useTxNotification } from '@/hooks/useTxNotification';
import './index.less';

const GetMarginButton: FC<IButtonProps> = function (props) {
  const userAddr = useUserAddr();
  const chainId = useChainId();
  const { mutate: sendAbcFaucetTx, isPending } = useAbcFaucetSendTx();
  const { open } = useTxNotification();
  const dappConfig = useDappChainConfig();

  /**
   * Handle button click to send ABC faucet transaction
   */
  const handleGetMargin = useCallback(() => {
    if (!userAddr) {
      console.warn('User address is not available');
      return;
    }
    if (!chainId) {
      console.warn('Chain ID is not available');
      return;
    }

    sendAbcFaucetTx(
      { to: userAddr, chainId },
      {
        onSuccess: async (result) => {
          const res = await result;
          console.log('ABC faucet transaction sent successfully:', res);
          // You can add success notification here
          open({
            type: 'success',
            message: 'Get margin successful',
            description: `${res?.amount} USDM sent to your wallet`,
          });
        },
        onError: (error) => {
          console.error('Failed to send ABC faucet transaction:', error);
          // You can add error notification here
          open({
            type: 'error',
            message: 'Get margin failed',
            description: 'Too many requests, please try again later.',
          });
        },
      },
    );
  }, [userAddr, sendAbcFaucetTx, open]);

  if (!dappConfig?.network?.isTestnet) {
    return null;
  }

  return (
    <Button
      size="small"
      className={'syn-get-margin-button'}
      type="primary"
      loading={isPending}
      disabled={!userAddr || isPending}
      onClick={handleGetMargin}
      {...props}>
      {isPending ? 'Loading' : 'Get Margin'}
    </Button>
  );
};

export default GetMarginButton;
